"use client"
import dynamic from "next/dynamic";
const Component = dynamic(() => import("./_component"));

const Index = ({ props }) => {

	return (
		<div className="mt-[70px]">
			{/* تنها h1 صفحه */}
			<h1 className="sr-only">دسته‌بندی محصولات</h1>

			<Component {...{ ...props }} />
		</div>
	)
};
export default Index;
